@if (form){
<div
  class="filters row"
  role="search"
  [formGroup]="form"
  (keydown.enter)="onSubmit()"
  >
    @for (filter of this.config(); track filter.column){
        <div class="col-12 col-md-3">
            @if (filter.type === 'text') {
              <div
                class="gov-form-control"
                [class.not-empty]="isControlFilled(filter.column)"
              >
                <input 
                  type="text" 
                  class="gov-form-control__input gov-js-input"
                  [id]="filter.column"
                  [formControlName]="filter.column">
                <label
                  class="gov-form-control__label filterLabel"
                  [for]="filter.column"
                >{{ filter.label | localize }}</label>
              </div>
            }
            @if (filter.type === 'select') {
              <app-gov-select-component
                [formControlName]="filter.column"
                [filterItem]="filter"
                [options]="optionsMap[filter.column] || []">
              </app-gov-select-component>
            }
            @if (filter.type === 'multiselect') {
              <app-custom-multiselect-component
                [formControlName]="filter.column"
                [filterItem]="filter"
                [options]="optionsMap[filter.column] || []"
              ></app-custom-multiselect-component>
            }
        </div>
    }
    <div class="buttons col-12">
        <button
        class="gov-button gov-button--primary gov-button--small"
        (click)="onSubmit()"
        >{{ 'sdg.grid.button.filter' | localize }}</button>
        <button
        class="gov-button gov-button--primary-outlined gov-button--small"
        (click)="onReset()"
        >{{ 'sdg.grid.button.reset' | localize }}</button>
    </div>
</div>
}
